import React from "react";
import { useGoogleAnalytics } from "../../../hooks/useGoogleAnalytics";

import { useLabels } from "../../../hooks/useLabels";

import { AutofillButton } from "../../autofill-button";
import { IconButton } from "../../icon-button";
import { ImportPhotosButton } from "../../import-photos-button";

import { Header } from "../header";

import { labels } from "./labels";

function DefaultHeaderLeft({ onClose }: { onClose(hasPendingUploads: false | undefined): void }) {
	return (
		<div className="header__left__wrapper">
			<div>
				<IconButton iconName="angle-left-slim" onClick={() => onClose(undefined)} />
			</div>
		</div>
	);
}

function DefaultHeaderRight({ hasPhotos, onSelect }: { hasPhotos: boolean; onSelect(): void }) {
	const [[selectLabel, autofillLabel]] = useLabels([labels.select, labels.autofill]);
	const googleAnalytics = useGoogleAnalytics();
	const logGAEvent = () => {
		googleAnalytics.trackEventToGa({
			trackingAction: "EPSAutofillClicked",
		});
	};

	return (
		<>
			{hasPhotos && <AutofillButton title={autofillLabel} logGAEvent={logGAEvent} />}

			<ImportPhotosButton containerClassName="PhotoSelectionScreenContainer" showTitle />

			{hasPhotos && (
				<IconButton iconName="check-circle" title={selectLabel} onClick={onSelect} />
			)}
		</>
	);
}

export function DefaultHeader({
	onClose,
	onSelect,
	hasPhotos,
}: {
	onClose(hasPendingUploads: false | undefined): void;
	onSelect(): void;
	hasPhotos: boolean;
}) {
	return (
		<Header
			left={<DefaultHeaderLeft onClose={onClose} />}
			right={<DefaultHeaderRight onSelect={onSelect} hasPhotos={hasPhotos} />}
		/>
	);
}
